export default {
    sagemaker: {
        nivel: "avanzado",
        cuando: ["Entrenar y desplegar tus propios modelos de machine learning.", "Equipos de ciencia de datos con ciclo completo (MLOps).", "Control del entrenamiento y la inferencia."],
        evita: ["Si un servicio listo (Rekognition, Comprehend, Textract) ya resuelve el problema.", "Solo usar un modelo de lenguaje: Bedrock."],
        alt: [["bedrock", "IA generativa lista para usar."], ["rekognition", "Visión sin entrenar."]],
        cobro: "Por hora de cada recurso (notebooks, entrenamiento, endpoints) según el tamaño de la instancia; los endpoints encendidos se cobran aunque no reciban tráfico.",
        con: ["s3", "ecr", "iam", "cloudwatch", "lambda"],
        quiz: { p: "¿Qué recurso responde predicciones en línea?", o: ["Un endpoint", "Un notebook", "Un snapshot"], c: 0, e: "El endpoint publica el modelo por HTTP." },
    },
    bedrock: {
        nivel: "intermedio",
        cuando: ["Incorporar IA generativa (texto, imagen, resumen, chat) por API.", "Respuestas basadas en tus documentos (RAG).", "Sin administrar infraestructura de modelos."],
        evita: ["Si necesitas entrenar un modelo propio desde cero: SageMaker.", "Tareas que ya resuelve un servicio especializado más barato."],
        alt: [["sagemaker", "Modelos propios."], ["q", "Asistente listo para empresas."], ["comprehend", "Análisis de texto clásico."]],
        cobro: "Por tokens de entrada y salida (o por imagen) según el modelo, o por capacidad reservada con Provisioned Throughput.",
        con: ["s3", "lambda", "opensearch", "kendra", "iam"],
        quiz: { p: "¿Qué permite una Knowledge Base?", o: ["Que el modelo responda con tus documentos", "Guardar facturas", "Crear redes"], c: 0, e: "Es la base del patrón RAG." },
    },
    rekognition: {
        nivel: "intermedio",
        cuando: ["Detectar objetos, rostros, texto o contenido inapropiado en imágenes y video.", "Verificación facial.", "Moderación automática."],
        evita: ["Reconocimiento propio muy específico: entrena un modelo en SageMaker.", "Usos de identificación con requisitos legales especiales sin evaluar su impacto."],
        alt: [["textract", "Texto de documentos."], ["sagemaker", "Modelos propios."]],
        cobro: "Por imagen analizada y por minuto de video procesado.",
        con: ["s3", "lambda", "kinesis"],
        quiz: { p: "¿Qué devuelve Rekognition junto a cada etiqueta?", o: ["Un puntaje de confianza", "Una factura", "Un certificado"], c: 0, e: "Indica qué tan seguro está el modelo." },
    },
    comprehend: {
        nivel: "intermedio",
        cuando: ["Sentimiento y temas de reseñas, correos y encuestas.", "Detectar datos personales en texto.", "Clasificar documentos."],
        evita: ["Generar texto: Bedrock.", "Traducir: Translate."],
        alt: [["bedrock", "IA generativa."], ["translate", "Traducción."]],
        cobro: "Por unidades de 100 caracteres analizadas, o por hora de endpoint de un modelo propio.",
        con: ["s3", "lambda", "textract"],
        quiz: { p: "¿Qué detecta Comprehend en un texto?", o: ["Sentimiento, entidades e idioma", "Fallas de red", "Virus"], c: 0, e: "Es procesamiento de lenguaje natural." },
    },
    textract: {
        nivel: "basico",
        cuando: ["Pasar facturas, formularios y cédulas escaneadas a datos estructurados.", "Extraer tablas.", "Automatizar el ingreso de documentos."],
        evita: ["Texto ya digital: léelo directamente.", "Reconocer objetos en fotos: Rekognition."],
        alt: [["rekognition", "Reconoce objetos y rostros en imágenes."], ["comprehend", "Análisis del texto extraído."]],
        cobro: "Por página analizada según el tipo de análisis (texto, tablas, formularios, facturas, identidad).",
        con: ["s3", "lambda", "comprehend"],
        quiz: { p: "¿Qué ventaja tiene Textract sobre un OCR simple?", o: ["Entiende tablas y pares campo-valor", "Es gratis", "No necesita imágenes"], c: 0, e: "Devuelve estructura y no solo texto." },
    },
    transcribe: {
        nivel: "basico",
        cuando: ["Convertir reuniones, llamadas y videos en texto.", "Subtítulos.", "Análisis de llamadas de un centro de contacto."],
        evita: ["Si necesitas el sentido del texto: combínalo con Comprehend o Bedrock."],
        alt: [["comprehend", "Analizar el texto."], ["polly", "Lo contrario: texto a voz."]],
        cobro: "Por segundo de audio procesado.",
        con: ["s3", "connect", "comprehend"],
        quiz: { p: "¿Qué hace Transcribe?", o: ["Voz a texto", "Texto a voz", "Traduce documentos"], c: 0, e: "Es reconocimiento automático del habla." },
    },
    polly: {
        nivel: "basico",
        cuando: ["Leer en voz alta contenidos y avisos.", "Asistentes y lecturas accesibles.", "Audio de artículos."],
        evita: ["Voz clonada de una persona real sin autorización."],
        alt: [["transcribe", "Voz a texto."], ["lex", "Conversación completa."]],
        cobro: "Por millón de caracteres sintetizados según el tipo de voz.",
        con: ["s3", "lambda", "lex"],
        quiz: { p: "¿Qué convierte Polly?", o: ["Texto en voz", "Voz en texto", "Video en audio"], c: 0, e: "Es síntesis de voz." },
    },
    translate: {
        nivel: "basico",
        cuando: ["Traducir contenido, chats y documentos.", "Localizar un sitio o aplicación.", "Traducción en tiempo real."],
        evita: ["Textos legales o contractuales sin revisión humana."],
        alt: [["bedrock", "Traducción con modelos generativos y contexto."]],
        cobro: "Por millón de caracteres traducidos.",
        con: ["s3", "lambda", "comprehend"],
        quiz: { p: "¿Qué permite la terminología personalizada?", o: ["Traducir siempre igual ciertos términos", "Cifrar textos", "Acelerar la red"], c: 0, e: "Respeta nombres de marcas y términos técnicos." },
    },
    lex: {
        nivel: "intermedio",
        cuando: ["Chatbots de texto y voz con comprensión de intención.", "Atención automática de clientes.", "Integración con Amazon Connect."],
        evita: ["Respuestas abiertas sobre cualquier tema: Bedrock.", "Preguntas simples con menús fijos."],
        alt: [["bedrock", "IA generativa."], ["connect", "Centro de contacto."]],
        cobro: "Por solicitud de texto o de voz procesada.",
        con: ["connect", "lambda", "polly", "transcribe"],
        quiz: { p: "¿Qué es un slot en Lex?", o: ["Un dato que el bot necesita obtener (fecha, destino)", "Un tipo de servidor", "Una clave"], c: 0, e: "El bot lo pregunta hasta completar la información." },
    },
    kendra: {
        nivel: "avanzado",
        cuando: ["Buscar con preguntas en lenguaje natural en documentos de la empresa.", "Intranets y bases de conocimiento.", "Respuestas con el documento de origen."],
        evita: ["Búsqueda simple por palabras: OpenSearch.", "Presupuestos muy ajustados: tiene costo base."],
        alt: [["opensearch", "Búsqueda por texto."], ["bedrock", "IA generativa con tus documentos."], ["q", "Asistente para empresas."]],
        cobro: "Por hora de índice (según su edición) más conectores y documentos; tiene un costo base aunque no se use.",
        con: ["s3", "bedrock", "q"],
        quiz: { p: "¿Qué se crea en Kendra?", o: ["Un índice de búsqueda con tus documentos", "Una red", "Una cuenta"], c: 0, e: "Los conectores alimentan el índice." },
    },
    forecast: {
        nivel: "avanzado",
        cuando: ["Pronosticar demanda, ventas o inventario.", "Series de tiempo con datos relacionados.", "Sin programar modelos."],
        evita: ["Datos sin historial suficiente.", "Si necesitas control total del modelo: SageMaker."],
        alt: [["sagemaker", "Modelos propios."]],
        cobro: "Por GB de datos importados, horas de entrenamiento y pronósticos generados.",
        con: ["s3", "sagemaker", "quicksight"],
        quiz: { p: "¿Qué necesita Forecast para predecir?", o: ["El historial de la serie de tiempo", "Una imagen", "Un certificado"], c: 0, e: "Aprende del pasado para proyectar el futuro." },
    },
    personalize: {
        nivel: "avanzado",
        cuando: ["Recomendar productos o contenido a cada usuario.", "Páginas de inicio personalizadas.", "Aprender del comportamiento reciente."],
        evita: ["Pocos usuarios o pocos datos de interacción."],
        alt: [["sagemaker", "Modelos propios."], ["opensearch", "Búsqueda de texto, no recomendaciones personalizadas."]],
        cobro: "Por GB de datos, por horas de entrenamiento y por solicitudes de recomendación.",
        con: ["s3", "lambda", "apigw"],
        quiz: { p: "¿Qué datos necesita Personalize?", o: ["Interacciones entre usuarios e ítems", "Solo facturas", "Solo fotos"], c: 0, e: "Aprende de quién interactuó con qué." },
    },
    q: {
        nivel: "intermedio",
        cuando: ["Preguntar a tus sistemas internos en lenguaje natural.", "Ayuda para desarrolladores.", "Respetando los permisos de cada persona."],
        evita: ["Procesos críticos sin revisión humana de la respuesta."],
        alt: [["bedrock", "Construir tu propia solución."], ["kendra", "Buscador empresarial."]],
        cobro: "Por usuario al mes según el plan.",
        con: ["bedrock", "kendra", "s3", "iam"],
        quiz: { p: "¿Qué respeta Amazon Q al responder?", o: ["Los permisos de cada persona sobre las fuentes", "Ninguna regla", "Solo la región"], c: 0, e: "Solo muestra lo que el usuario puede ver." },
    },
};
